module.exports = __webpack_public_path__ + "static/media/CourseNewCourseGreen.d861cbd6.svg";